<template>
  <b-card>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength,
      }"
    >
    <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'companyName'">
          <feather-icon icon="BriefcaseIcon" class="mr-50" />ผู้ประกอบการ /
          <feather-icon icon="UserIcon" class="mr-50" />ชื่อผู้ร้องทุกข์ /
          <feather-icon icon="UsersIcon" class="mr-50" /> ผู้มอบอำนาจ
        </span>
        <span v-else>
          {{ props.column.label }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'complaintCode'" class="text-nowrap">
          <!-- <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          /> -->
          <span class="text-nowrap">{{ props.row.complaintCode }}</span>
          <br />
          <span class="text-nowrap"
            ><i class="flaticon2-open-text-book" />
            {{ props.row.sarabunCode }}</span
          >
        </span>

        <!-- Column: Name -->
        <span v-if="props.column.field === 'companyName'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.companyName }} <br /> </span>

          <span v-for="(item, index) in props.row.complainantJsonList.filter(function (value) {return value.role === 3})" :key="index" class="text-nowarp">
            <feather-icon icon="UserIcon" class="mr-50" />{{item.fName}} {{item.lName}}
            <br />
          </span>

          <span v-for="(item, index) in props.row.complainantJsonList.filter(function (value) {return value.role === 8})" :key="index" class="text-nowarp">
            <feather-icon icon="UsersIcon" class="mr-50" />{{item.fName}} {{item.lName}}
            <br />
          </span>

          <!-- <span
            v-if="props.row.attorneyname != null"
            class="text-nowrap"
          >{{ props.row.attorneyname }}</span>
          <span
            v-else
            class="text-nowrap"
          >-</span> -->
        </span>
        <!-- Column: Complain_Subject -->
        <span v-if="props.column.field === 'status'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.complaintDateStr }} - {{ props.row.slaDate }}
          </span>
          <br />
          <span class="text-nowarp">
            {{ props.row.leveldescription }}-{{ props.row.statusdescription }}
          </span>
        </span>
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <!-- <span v-if="tabMode == 'List'">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="btn-icon "
              @click="onComplainSend"
            >
              <feather-icon icon="SendIcon" class="mr-50" />
              <span class="align-middle">ส่งต่อ</span>
            </b-button>
          </span>
          <span v-else> -->
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="text-body align-middle mr-25"
                >
                  <feather-icon icon="SettingsIcon" class="mr-50" />
                  <span class="align-middle">จัดการ</span>
                </b-button>
              </template>
              <b-dropdown-item
                @click="onComplainGroupManage(props.row.complaintId)"
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="confirmText">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <!-- <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span> -->
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>

</template>

<script>
import {
  BButton, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard, BCardHeader, BCardBody,
  BFormCheckboxGroup, BFormCheckbox, // ,BRow, BCol, BFormTextarea, BFormRadio, BTab, BTabs,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { codeBasic } from '@/views/table/vue-good-table/code'
import store from '@/store/index'


export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  props: {
    rows: [],
  },
  setup(props) {
  },
  data() {
    return {

      pageLength: 100,
      dir: false,
      codeBasic,
      columns: [
        {
    label: 'เลขร้องทุกข์',
    field: 'complaintCode',
  },
  {
    label: 'ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ / ผู้มอบอำนาจ',
    field: 'companyName',
  },
  {
    label: 'วันที่ยื่นเรื่อง - วันที่ต้องดำเนินการ / สถานะดำเนินการ',
    field: 'status',
  },
      ],
      searchTerm: '',
      status: [{
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      {
        1: 'light-primary',
        2: 'light-success',
        3: 'light-danger',
        4: 'light-warning',
        5: 'light-info',
      }],
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current      : 'light-primary',
        Professional : 'light-success',
        Rejected     : 'light-danger',
        Resigned     : 'light-warning',
        Applied      : 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
